import * as actions from '../services'
import * as types from './mutations-types'
import { addFlash } from 'src/app/components/shareds/flash/vuex/mutations-types'
import { t } from 'src/utils/form'

export const attemptLogin = (context, payload) => {
  return actions.postLogin(payload.email, payload.password)
  .then(function (response) {
    if (response && response.status === 200) {
      context.commit(types.setUserToken, response.data.auth_token)
      context.commit(types.setUser, response.data.user)
    } else if (response && response.status === 401) {
      context.commit(addFlash, { message: t(context, 'login.alert.login_error'), type: 'ls-alert-danger' })
    }
    return response
  })
}

export const attemptLoginWithSubdomain = (context, payload) => {
  return actions.postLoginWithSubdomain(payload.email, payload.password, payload.subdomain)
    .then(function (response) {
      if (response && response.status === 200) {
        context.commit(types.setUserToken, response.data.auth_token)
        context.commit(types.setUser, response.data.user)
        context.dispatch('loadUserPermissions', response.data.user.id).then(function () {
          context.commit(types.setIsLogged, true)
        })
        context.commit(types.setSubdomain, response.data.user.seller.subdomain)
      } else if (response && response.status === 401) {
        context.commit(addFlash, { message: t(context, 'login.alert.login_error'), type: 'ls-alert-danger' })
      } else if (response === undefined) {
        context.commit(addFlash, { message: t(context, 'login.alert.invalid_domain'), type: 'ls-alert-danger' })
      }
      return response
    })
}

export const attemptAdmLogin = (context, payload) => {
  return actions.postAdmLogin(payload)
  .then(function (response) {
    if (response && response.status === 200) {
      context.commit(types.setUserToken, response.data.auth_token)
      context.commit(types.setAdmUser, response.data)
      context.commit(types.setUser, response.data.user)
    } else if (response && response.status === 401) {
      context.commit(addFlash, { message: t(context, 'login.alert.login_error'), type: 'ls-alert-danger' })
    }
    return response
  })
}

export const attemptCustomerLogin = (context, payload) => {
  return actions.postCustomerLogin(payload.email, payload.password)
  .then(function (response) {
    if (response && response.status === 200) {
      context.commit(types.setCustomerToken, response.data.auth_token)
      context.commit(types.setCust, response.data.customer)
    } else if (response && response.status === 401) {
      context.commit(types.setCust, {})
      context.commit(addFlash, { message: t(context, 'login.alert.login_error'), type: 'ls-alert-danger' })
    }
    return response
  })
}

export const retrieveCustomerData = (context, payload) => {
  return actions.getCustomerData(payload)
  .then(function (response) {
    if (response && response.status === 200) {
      let customer = response.data.customer
      customer.access_time = new Date().getTime()
      context.commit(types.setCust, customer)
      if (response.data.customer.cpf) {
        window.localStorage.setItem('customerCPF', JSON.stringify(response.data.customer.cpf))
      }
    } else if (response && response.status === 401) {
      context.commit(addFlash, { message: t(context, 'customer.alert.retrieve_error'), type: 'ls-alert-danger' })
    }
    return response
  })
}

export const createCustomerWithoutLogin = (context, payload) => {
  return actions.newCustomer({ customer: payload })
    .then(function (response) {
      if (response.status === 201) {
        context.commit(addFlash, {message: t(context, 'customers.alert.created'), type: 'ls-alert-success'})
      } else {
        context.commit(addFlash, {message: t(context, 'customers.alert.not_created'), type: 'ls-alert-danger'})
      }
      return response
    })
}

export const updateCustomerWithoutLogin = (context, payload) => {
  return actions.updateCustomer({ customer: payload })
    .then(function (response) {
      if (response.status === 200) {
        context.commit(addFlash, {message: t(context, 'customers.alert.updated'), type: 'ls-alert-success'})
      } else {
        context.commit(addFlash, {message: t(context, 'customers.alert.not_updated'), type: 'ls-alert-danger'})
      }
      return response
    })
}

export const createCustomer = (context, payload) => {
  return actions.newCustomer({ customer: payload })
  .then(function (response) {
    if (response && response.status === 201) {
      let customer = response.data.customer
      customer.access_time = new Date().getTime()
      context.commit(types.setCustomerToken, response.data.customer.auth_token)
      context.commit(types.setCust, customer)
    }
    return response
  })
}

export const definePassword = (context, payload) => {
  return actions.updateCustomer({ customer: payload })
    .then(function (response) {
      if (response && response.status === 200) {
        let customer = response.data.customer
        customer.access_time = new Date().getTime()
        context.commit(types.setCust, customer)
        context.commit(types.setCustomerToken, response.data.customer.auth_token)
        context.commit(addFlash, { message: t(context, 'application.reset_password.first_access'), type: 'ls-alert-success' })
      } else {
        context.commit(addFlash, { message: t(context, 'application.reset_password.fail'), type: 'ls-alert-danger' })
      }
      return response
    })
}

export const editCustomer = (context, payload) => {
  const oldSessionTime = payload.sessionTime
  return actions.updateCustomer(payload)
  .then(function (response) {
    if (response && response.status === 200 || response.status === 304) {
      let customer = response.data.customer
      customer.access_time = oldSessionTime
      context.commit(types.setCust, customer)
    }
    return response
  })
}

export const recoverPassword = (context, payload) => {
  return actions.resetPassword(payload.email)
  .then(function (response) {
    if (response && response.status === 200) {
      context.commit(addFlash, { message: t(context, 'application.reset_password.email_sent'), type: 'ls-alert-success' })
    } else if (response && response.status === 404) {
      context.commit(addFlash, { message: t(context, 'application.reset_password.email_not_found'), type: 'ls-alert-danger' })
    }
    return response
  })
}

export const editPassword = (context, payload) => {
  return actions.updatePassword(payload)
  .then(function (response) {
    if (response && response.status === 200) {
      context.commit(addFlash, { message: t(context, 'application.reset_password.success'), type: 'ls-alert-success' })
    } else if (response && response.status === 404) {
      context.commit(addFlash, { message: t(context, 'application.reset_password.token_not_found'), type: 'ls-alert-danger' })
    }
    return response
  })
}
export const loadFullUser = (context) => {
  let userId = context.state.user.id

  if (userId === undefined) {
    userId = 1
  }

  return actions.getUser(userId)
    .then(function (response) {
      if (response && response.status === 200) {
        context.commit(types.setUser, response.data.user)
      }
      return response
    })
}

export const loadSeller = async (context) => {
  return await actions.getSeller()
    .then(function (response) {
      if (response && response.status === 200) {
        context.commit(types.setSeller, response.data.seller)
      }
      return response
    })
}

export const logoutYapayLogin = async (context, payload) => {
  return await actions.logoutYapayLogin(payload)
    .then(function (response) {
      return response
    })
}



// WEBPACK FOOTER //
// ./src/app/pages/auth/vuex/actions.js